import type { PageModel } from '@site/shared'
import { mapBlocks } from './blocks'

type RawPage = {
  id: number | string
  slug: string
  title: string
  seoTitle?: string
  seoDescription?: string
  updatedAt?: string
  sections?: unknown[]
}

export function mapPage(raw: RawPage, baseUrl: string): PageModel {
  return {
    id: String(raw.id),
    slug: raw.slug,
    title: raw.title,
    seoTitle: raw.seoTitle || undefined,
    seoDescription: raw.seoDescription || undefined,
    updatedAt: raw.updatedAt,
    sections: mapBlocks(raw.sections ?? [], baseUrl),
  }
}
